<template>
  <div id="app">
    <div
      class="page-container"
      :class="{ 'with-tabbar': !($route.meta && $route.meta.hideTabbar) }"
    >
      <router-view />
    </div>
    <TabbarMain v-if="!($route.meta && $route.meta.hideTabbar)" />

    <!-- 全局加载组件 -->
    <LoadingOverlay :isLoading="isGlobalLoading" :loadingText="loadingText" />
  </div>
</template>

<script>
import TabbarMain from "@/components/TabbarMain.vue";
import LoadingOverlay from "@/components/LoadingOverlay.vue";

export default {
  name: "App",
  components: {
    TabbarMain,
    LoadingOverlay
  },
  data() {
    return {
      isGlobalLoading: false,
      loadingText: ""
    };
  },
  watch: {
    $route() {
      document.title = "早鹰观影";
    }
  },
  created() {
    // 监听全局加载状态
    this.$root.$on("showGlobalLoading", (text = "") => {
      this.isGlobalLoading = true;
      this.loadingText = text;
    });

    this.$root.$on("hideGlobalLoading", () => {
      this.isGlobalLoading = false;
      this.loadingText = "";
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off("showGlobalLoading");
    this.$root.$off("hideGlobalLoading");
  }
};
</script>

<style>
/* 重置样式 */
#app {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
#app {
  height: 100%;
  /* 防止页面缩放和左右滑动 */
  overflow-x: hidden;
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Global fix: ensure Element UI dialogs are above their masks (iOS Safari stacking) */
body .el-dialog__wrapper {
  z-index: 3000 !important;
}
body .v-modal,
body .el-overlay {
  z-index: 2999 !important;
}
body .el-dialog {
  z-index: 3001 !important;
  pointer-events: auto !important;
}

/* 响应式基础样式 */
.page-container {
  min-height: 100vh;
  box-sizing: border-box;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
  /* 防止页面晃动和意外滑动 */
  position: relative;
  touch-action: pan-y;
  overscroll-behavior: none;
  -webkit-overflow-scrolling: touch;
}
.page-container.with-tabbar {
  padding-bottom: 60px; /* 默认高度 */
}

/* 响应式断点 */
/* 手机端: 320px - 767px */
@media (max-width: 767px) {
  .page-container {
    /* padding: 0 16px; */
  }
  .page-container.with-tabbar {
    padding-bottom: calc(
      56px + env(safe-area-inset-bottom)
    ); /* 手机端导航栏高度 + 安全区域 */
  }
}

/* 平板端: 768px - 1023px */
@media (min-width: 768px) and (max-width: 1023px) {
  .page-container {
    /* padding: 0 24px; */
    max-width: 768px;
    margin: 0 auto;
  }
  .page-container.with-tabbar {
    padding-bottom: 64px; /* 平板端导航栏高度 */
  }

  /* 平板端底部导航栏全宽显示 */
  .tabbar {
    max-width: none !important;
    width: 100% !important;
    left: 0 !important;
    right: 0 !important;
    margin: 0 !important;
  }
}

/* 桌面端: 1024px+ */
@media (min-width: 1024px) {
  .page-container {
    /* padding: 0 32px; */
    max-width: 1200px;
    margin: 0 auto;
  }
  .page-container.with-tabbar {
    padding-bottom: 70px; /* 桌面端导航栏高度 */
  }

  /* 桌面端底部导航栏全宽显示 */
  .tabbar {
    max-width: none !important;
    width: 100% !important;
    left: 0 !important;
    right: 0 !important;
    margin: 0 !important;
  }
}

/* 通用响应式工具类 */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
}

@media (min-width: 768px) {
  .container {
    padding: 0 24px;
  }
}

@media (min-width: 1024px) {
  .container {
    padding: 0 32px;
  }
}

/* 响应式文字大小 */
.text-responsive {
  font-size: 14px;
}

@media (min-width: 768px) {
  .text-responsive {
    font-size: 16px;
  }
}

@media (min-width: 1024px) {
  .text-responsive {
    font-size: 18px;
  }
}

/* 响应式间距 */
.spacing-responsive {
  padding: 16px;
}

@media (min-width: 768px) {
  .spacing-responsive {
    padding: 24px;
  }
}

@media (min-width: 1024px) {
  .spacing-responsive {
    padding: 32px;
  }
}
</style>
